<template>
  <div class="d-flex justify-center">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-btn icon color="primary" v-bind="attrs" v-on="on" @click="viewDetails">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <span>View Details</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-btn icon color="primary" v-bind="attrs" v-on="on" @click="viewLogs">
          <v-icon>mdi-history</v-icon>
        </v-btn>
      </template>
      <span>Logs</span>
    </v-tooltip>
    <v-tooltip top v-if="!hasTrailer">
      <template #activator="{ on, attrs }">
        <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click="updateTrailer">
          <v-icon>mdi-truck-trailer</v-icon>
        </v-btn>
      </template>
      <span>Update Trailer</span>
    </v-tooltip>
    <v-tooltip top v-if="canDelete">
      <template #activator="{ on, attrs }">
        <v-btn icon color="error" v-bind="attrs" v-on="on" @click="deleteTrip">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
      <span>Delete Trip</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  computed: {
    hasTrailer() {
      const data = this.params.data || {};
      if (data.trailer_mode === "Boggie") {
        return !!data.trailer_1_number && !!data.trailer_2_number;
      }
      return !!data.trailer_1_number;
    },
    canDelete() {
      const data = this.params.data || {};
      return (
        ["Assigned", "Active"].includes(data.status) &&
        (data.leg_count || 0) === 0
      );
    },
  },
  methods: {
    viewDetails() {
      this.params.context.parentComponent.openTripDetails(this.params.data);
    },
    updateTrailer() {
      this.params.context.parentComponent.openUpdateTrailer(this.params.data);
    },
    viewLogs() {
      this.params.context.parentComponent.openTripLogs(this.params.data);
    },
    deleteTrip() {
      this.params.context.parentComponent.openDeleteTrip(this.params.data);
    },
  },
};
</script>
